import React from "react";
import { languages } from "../../constants/languages";
import teamPicture from "../../img/team.png";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import EditTeamContainer from "../../containers/teams/EditTeamContainer";
import EditRefereeContainer from "../../containers/schedule/EditRefereeContainer";
import EditAdminContainer from "../../containers/admins/EditAdminContainer";
import refereePicture from "../../img/referee2.png";
import adminPicture from "../../img/admin.png";
import TeamsAsRefereesContainer from "../../containers/teams/TeamsAsRefereesContainer";

const NoTeamsMessage = (props) => (
  <div style={{ width: "95%", textAlign: "center" }}>
    <div style={{ maxWidth: 700, display: "inline-block" }}>
      <img
        src={
          props.refereesPage
            ? refereePicture
            : props.adminsPage
            ? adminPicture
            : teamPicture
        }
        alt=""
        style={{ height: 100, margin: "20px 0 15px 0" }}
      />
      <Typography variant="h6">
        {props.refereesPage
          ? props.tournament.useJudges
            ? languages.referees.noJudgesMessage2
            : languages.referees.noRefereesMessage2
          : props.adminsPage
          ? languages.admins.noAdminsMessageTitle
          : props.divisions.length > 1
          ? languages.formatString(
              languages.teams.noTeamsMessageTitleDivision,
              props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )
          : languages.formatString(
              languages.teams.noTeamsMessageTitle,
              props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
      </Typography>
      {!props.refereesPage && !props.adminsPage && (
        <Typography variant="subtitle1" style={{ fontSize: 17 }}>
          {languages.teams.noTeamsMessageDescription1 + " "}
          <Link to={"/tournament/" + props.tournament[".key"] + "/structure"}>
            {languages.tournament.allocation.toLowerCase()}
          </Link>
          {" " +
            languages.formatString(
              languages.teams.noTeamsMessageDescription2,
              props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
        </Typography>
      )}
      {props.refereesPage && (
        <Typography variant="subtitle1" style={{ fontSize: 17 }}>
          {props.tournament.useJudges
            ? languages.referees.noJudgesMessage2Description + "."
            : languages.referees.noRefereesMessage2Description + "."}
        </Typography>
      )}
      {props.adminsPage && (
        <Typography variant="subtitle1" style={{ fontSize: 17 }}>
          {languages.admins.description}
        </Typography>
      )}
      <div style={{ marginTop: 15 }}>
        {props.refereesPage ? (
          <div>
            <EditRefereeContainer
              tournament={props.tournament}
              sportParks={props.sportParks}
              days={props.days}
              divisions={props.divisions}
              allTeams={props.allTeams}
              allTeamsByKey={props.allTeamsByKey}
            />
            <br />
            <TeamsAsRefereesContainer
              tournament={props.tournament}
              allTeams={props.allTeams}
              teams={props.teams}
            />
          </div>
        ) : props.adminsPage ? (
          <EditAdminContainer tournament={props.tournament} />
        ) : (
          <EditTeamContainer
            tournament={props.tournament}
            division={props.division}
            refereesPage={props.refereesPage}
          />
        )}
      </div>
      {!props.refereesPage && !props.adminsPage && (
        <div
          style={{
            fontSize: 12,
            cursor: "pointer",
            marginTop: 15,
          }}
          onClick={(e) => {
            props.handleToPlayersClick(
              e,
              props.tournament.individualPlayers ? false : true
            );
          }}
        >
          {props.tournament.individualPlayers
            ? languages.teamInfo.toTeamSport
            : languages.teamInfo.toIndividualSport}
        </div>
      )}
    </div>
  </div>
);

export default NoTeamsMessage;
